





































import { Component, Watch } from 'vue-property-decorator';
import { AwardIcon, BellIcon, FilterIcon, MenuIcon, SearchIcon, UserIcon } from 'vue-feather-icons';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import NoFilter from '@/components/common/NoFilter.vue';
import Avatar from '@/components/common/Avatar.vue';
import EmployeesFilter from '@/components/employees/EmployeesFilter.vue';
import { PreferencesAction } from '@/store/PreferencesModule';
import PolicyFilterComponent from '@/components/filters/PolicyFilter.vue';
import AntragsbuchFilterComponent from '@/components/filters/AntragsbuchFilter.vue';
import GenericFilter from '@/components/filters/GenericFilter.vue';
import BusinessPlanFilterComponent from '@/views/pages/fivgoals/BusinessPlanFilter.vue';
import BusinessPlanPlusFilterComponent from '@/views/pages/fivgoals/BusinessPlanPlusFilter.vue';
import {
  AgencyStatus,
  FivGoalGroupType,
  GetGoalGroupDto,
  IFivReport,
  isBusinessPlanPlusReport,
  isBusinessPlanReport,
  isCompetitionsKbvReport,
  isCompetitionsReport,
  IUploadBusinessPlanReport,
  IUploadCompetitionsReport,
  ReportParser,
  UserSpecialType,
} from 'admiral-core';
import BusinessPlanReportConfirmation from '@/modals/BusinessPlanReportConfirmation.vue';
import { BusinessPlanApi } from '@/services/BusinessPlanApi';
import { FivApi } from '@/services/FivApi';
import CompetitionsReportConfirmation from '@/modals/CompetitionsReportConfirmation.vue';
import { CompetitionsApi } from '@/services/CompetitionsApi';
import KbvFilterComponent from '@/components/filters/KbvFilter.vue';
import NotificationOverview from '@/components/common/NotificationOverview.vue';
import TaskFilterComponent from '@/components/filters/TaskFilter.vue';
import FivGoalsFilterComponent from '@/components/filters/FivGoalsFilter.vue';
import BlurryLink from '@/components/common/BlurryLink.vue';
import DemoDataToggle from '@/components/common/DemoDataToggle.vue';
import UserMenuDropdown from '@/components/UserMenuDropdown.vue';
import StatisticFilterComponent from '@/components/filters/StatisticFilter.vue';
import DamageFilterComponent from '@/components/filters/DamageFilter.vue';

@Component({
  components: {
    UserMenuDropdown,
    BlurryLink,
    DemoDataToggle,
    NotificationOverview,
    Avatar,
    AwardIcon,
    SearchIcon,
    BellIcon,
    MenuIcon,
    UserIcon,
    NoFilter,
    EmployeesFilter,
    FilterIcon,
    'business-plan-report-confirmation2': BusinessPlanReportConfirmation,
    'competitions-report-confirmation2': CompetitionsReportConfirmation,
    GenericFilter,
    'policy-filter': PolicyFilterComponent,
    'antragsbuch-filter': AntragsbuchFilterComponent,
    'statistic-filter': StatisticFilterComponent,
    'damage-filter': DamageFilterComponent,
    'fiv-goals-filter': FivGoalsFilterComponent,
    'businessplan-filter': BusinessPlanFilterComponent,
    'businessplan-plus-filter': BusinessPlanPlusFilterComponent,
    'kbv-filter': KbvFilterComponent,
    'task-filter': TaskFilterComponent,
  },
})
export default class MainHeader extends mixins(BaseMixin) {
  timeoutCountDown = 180 * 60;

  uploadedBusinessPlanReport: IUploadBusinessPlanReport | null = null;
  uploadedCompetitionsReport: IUploadCompetitionsReport | null = null;

  // @ts-ignore @typescript-eslint/no-explicit-any
  timer: any;

  get filter() {
    return `${(this.$route.meta as any).filter || 'no-filter'}`;
  }

  get sensitiveData() {
    return !!(this.$route.meta as any).sensitiveData;
  }

  get isDemo() {
    return this.user.agency.status === AgencyStatus.DEMO;
  }

  async mounted() {
    this.timeoutCountDown = Math.round(
      (new Date(this.automaticLogoutTime).getTime() - new Date().getTime()) / 1000,
    );
    await this.countDownTimer();

    document.body.addEventListener('paste', async (event) => {
      // @ts-ignore
      const paste = (event.clipboardData || window.clipboardData).getData('text');
      const report = ReportParser.fromClipboard(paste);

      const goalGroupDto: GetGoalGroupDto = {
        groupType: FivGoalGroupType.BusinessPlan,
        year: this.fivGoalsFilter.year,
      };

      if (!report) {
        return;
      }

      if (isBusinessPlanReport(report)) {
        goalGroupDto.groupType = FivGoalGroupType.BusinessPlan;
        goalGroupDto.agency = this.agency;
      } else if (isBusinessPlanPlusReport(report)) {
        goalGroupDto.groupType = FivGoalGroupType.BusinessPlanPlus;
        goalGroupDto.user = this.user;
      } else if (isCompetitionsReport(report)) {
        goalGroupDto.groupType = FivGoalGroupType.Competitions;
        goalGroupDto.agency = this.agency;
      } else if (isCompetitionsKbvReport(report)) {
        goalGroupDto.groupType = FivGoalGroupType.CompetitionsKbv;
        goalGroupDto.user = this.user;
      }

      const response = await FivApi.getGoalGroup(goalGroupDto);
      report.goalGroup = response.data;

      if (isBusinessPlanReport(report) || isBusinessPlanPlusReport(report)) {
        if (!this.uploadedBusinessPlanReport) {
          this.uploadedBusinessPlanReport = {
            status: 'new',
            missingReports: [],
            parts: [report],
          };
        } else {
          const existingReportIndex = (this.uploadedBusinessPlanReport.parts || []).findIndex(
            (part) => part.name === report.name,
          );
          // remove element from array
          if (existingReportIndex > -1) {
            this.uploadedBusinessPlanReport.parts!.splice(existingReportIndex, 1);
          }

          this.uploadedBusinessPlanReport.parts?.push(report);
        }

        const responseValidate = await BusinessPlanApi.validateUploadedBusinessPlanReport(
          this.uploadedBusinessPlanReport,
        );
        this.uploadedBusinessPlanReport = responseValidate.data;
        (this.$refs['business-plan-report-confirmation'] as any).$refs[
          'business-plan-report-confirmation-modal'
        ].show();
      } else if (isCompetitionsReport(report) || isCompetitionsKbvReport(report)) {
        if (!this.uploadedCompetitionsReport) {
          this.uploadedCompetitionsReport = {
            status: 'new',
            parts: [report],
          };
        } else {
          this.uploadedCompetitionsReport.parts?.push(report);
        }

        const responseValidate = await CompetitionsApi.validateUploadedCompetitionsReport(
          this.uploadedCompetitionsReport,
        );
        this.uploadedCompetitionsReport = responseValidate.data;

        (this.$refs['competitions-report-confirmation'] as any).$refs[
          'competitions-report-confirmation-modal'
        ].show();
      }

      event.preventDefault();
    });
  }

  get formattedTimer() {
    const minutes = Math.floor(this.timeoutCountDown / 60);
    const seconds = this.timeoutCountDown % 60;
    return `${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
  }

  async countDownTimer() {
    if (this.user) {
      if (this.timeoutCountDown > 0) {
        this.timer = setTimeout(async () => {
          this.timeoutCountDown -= 1;
          await this.countDownTimer();
        }, 1000);
      } else {
        if (this.timer) {
          clearTimeout(this.timer);
        }
        await this.handleLogout(true);
      }
    }
  }
  @Watch('automaticLogoutTime', { deep: true })
  async onChangeAutomaticLogoutTime() {
    this.timeoutCountDown = Math.round(
      (new Date(this.automaticLogoutTime).getTime() - new Date().getTime()) / 1000,
    );
    if (this.timer) {
      clearTimeout(this.timer);
    }
    await this.countDownTimer();
  }

  async handleExpandMobileMenu() {
    await this.$store.dispatch(`PreferencesModule/${PreferencesAction.expandMobileMenu}`, true);
  }

  cancelBusinessPlanUpload() {
    this.uploadedBusinessPlanReport = null;
  }
  cancelCompetitionsUpload() {
    this.uploadedCompetitionsReport = null;
  }

  async reportUploadComplete(report: IFivReport) {
    this.uploadedBusinessPlanReport = null;
    this.uploadedCompetitionsReport = null;

    if (isBusinessPlanReport(report)) {
      if (this.$route.name !== 'agency.goals.businessplan') {
        await this.$router.push({ name: 'agency.goals.businessplan' });
      } else {
        window.location.reload();
      }
    } else if (isBusinessPlanPlusReport(report)) {
      if (this.$route.name !== 'my.goals.businessplan-plus') {
        if (this.user.type === UserSpecialType.Kbv) {
          await this.$router.push({ name: 'my.goals.businessplan-plus' });
        } else {
          await this.$router.push({ name: 'agency.goals.kbv.businessplan-plus' });
        }
      } else {
        window.location.reload();
      }
    } else if (isCompetitionsReport(report)) {
      if (
        this.$route.name !== 'agency.goals.competitions.ring' &&
        this.$route.name !== 'agency.goals.competitions.hess' &&
        this.$route.name !== 'agency.goals.competitions.fallads'
      ) {
        await this.$router.push({ name: 'agency.goals.competitions.ring' });
      } else {
        window.location.reload();
      }
    } else if (isCompetitionsKbvReport(report)) {
      if (this.$route.name !== 'my.goals.winnersclub') {
        if (this.user.type === UserSpecialType.Kbv) {
          await this.$router.push({ name: 'my.goals.winnersclub' });
        } else {
          await this.$router.push({ name: 'agency.goals.kbv.winnersclub' });
        }
      } else {
        window.location.reload();
      }
    }
  }
}
